import { render, staticRenderFns } from "./VideoBlogs.vue?vue&type=template&id=7329ff1c&scoped=true&"
import script from "./VideoBlogs.vue?vue&type=script&lang=ts&"
export * from "./VideoBlogs.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBlogs.vue?vue&type=style&index=0&id=7329ff1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7329ff1c",
  null
  
)

export default component.exports